import { cx, css } from 'emotion';
import {
	museo900,
	headingLarge,
	tabletLandscapeMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const wrapperStyle = background =>
	css({
		background: background,
		display: 'flex',
		width: '100%',
		height: '160px',
		borderRadius: '6px',
		margin: '12px',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			height: 'auto',
		},
	});

export const imageStyle = css({
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const contentStyle = css({
	padding: '30px',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		padding: '24px 10px',
	},
});

export const titleStyle = css({
	...museo900,
	fontSize: '12px',
	lineHeight: '14px',
	margin: '0 0 5px 0',
	color: '#fff',
	textTransform: 'uppercase',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		marginBottom: '13px',
	},
});

export const bodyStyle = cx(
	headingLarge,
	css({
		color: '#fff',
		[`@media (max-width: ${tabletLandscapeMaxWidthBreakpoint}px)`]: {
			fontSize: '30px',
			lineHeight: '36px',
		},
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			fontSize: '20px',
			lineHeight: '24px',
		},
	})
);



// WEBPACK FOOTER //
// ./src/components/shared/comingSoon/styles.js